module.exports = __webpack_public_path__ + "img/jmlogo_white.9febb230.png";